export default __webpack_public_path__ + "static/media/thumbnail_blog_8.91270c15.jpg";